import Image from "next/image";

const FocusSection = () => {
  return (
    <div className="px-8 pt-8 md:px-24 md:pt-24 bg-background-low-em">
      <div className="grid grid-cols-12 max-w-[1440px] mx-auto">
        <div className="col-span-12 lg:col-span-6 flex flex-col justify-center items-end pb-8">
          <div
            className="flex flex-col space-y-6 md:text-left w-full 
             text-text-color-mid-em text-body-xl">
            <div className="flex space-x-5 items-center btn-text-xs xs:btn-text-base">
              <span className="bg-secondary-dark text-light px-2 py-1 rounded-full">
                New Feature
              </span>
              <span className="text-secondary-dark">Built for growth</span>
            </div>
            <span className="mobile-h1 md:h3 lg:h1 text-background-primary-dark">
              Focus on Business, not Bidding.
            </span>
            <span>Look no further. Here, opportunities find you.</span>
            <span>
              We’re in the business of connecting the most qualified vendors to
              the best possible opportunities.
            </span>
          </div>
        </div>
        <div className="col-span-12 px-8 md:px-16 lg:col-span-6 flex items-end justify-center">
          <div className="flex flex-col justify-end">
            <Image
              src="/images/haulers/focus.png"
              alt="focus"
              width={537}
              height={570}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FocusSection;
